<script>
export default {
  name: "RightDropMenu",
  props:{
    diff:{
      type:Boolean,
      default:false
    },
    years:{
      type:Array,
      default: () => []
    },
    onclickTrues:{
      type:Boolean
    },

    courseList:{
      type: Array,
      default: () => [
        { master_course_id: 16, master_course_name: "Chat Room" }
      ]
    }
    },
    data () {
      return {
          SheetStateYear:false,
          SheetStateMonth:false,
          year:new Date().getFullYear(),
          currentIndex: 0,
          month:{
              cn:'1',
              hk:'January'
          },
          months:[
              {cn:"1",hk:"January"},
              {cn:"2",hk:"February"},
              {cn:"3",hk:"March"},
              {cn:"4",hk:"April"},
              {cn:"5",hk:"May"},
              {cn:"6",hk:"June"},
              {cn:"7",hk:"July"},
              {cn:"8",hk:"August"},
              {cn:"9",hk:"September"},
              {cn:"10",hk:"October"},
              {cn:"11",hk:"November"},
              {cn:"12",hk:"December"},
          ],
          currentYear:new Date().getFullYear(), //添加当前年份变量
          currentMonth:new Date().getMonth() + 1 // 添加当前月份变量
      }
    },
    computed:{
      filteredMonths(){
          // 根据当前年份返回不同的月份数据
          return this.year === this.currentYear ? this.months.slice(0,this.currentMonth) : this.months
      },
      currentCourseName() {
          const list = Array.isArray(this.courseList) ? this.courseList : []
          const course = list[this.currentIndex]
          return course && course.master_course_name ? course.master_course_name : ''
      }
    },
    watch: {
      courseList() {
          this.currentIndex = 0
          this.currentCourse = null
      }
    },
    mounted() {
    },
    methods: {
      handleYearClick(item){
          this.year = item
          this.SheetStateYear = false
          const list = this.filteredMonths
          this.month = list.length ? list[0] : this.months[0]
      },
      handleMonthClick(item){
          this.month = item
          this.SheetStateMonth = false
      },
      handleClick(item,index) {
        this.currentCourse = item
        this.currentIndex = index
        this.SheetStateYear = false
      },
      confirmData() {
          if(this.diff) {
            const list = Array.isArray(this.courseList) ? this.courseList : []
            const course = this.currentCourse || list[this.currentIndex] || null
            this.$emit('confirmData', course)
          }else{
            this.$emit('confirmData',this.year,this.month)
          }
      },
    }
}
</script>

<template>
    <div class="right_drop_menu">
      <div style="display: flex; align-items: center; flex-direction: column" v-if="!diff">
        <div class="drop_item" @mouseenter="SheetStateYear = true" @mouseleave="SheetStateYear = false">
          <div class="src">
            <div>{{year}}</div>
            <img src="../../assets/images/downward01.png" v-if="!SheetStateYear" alt="" @click="SheetStateYear = !SheetStateYear">
            <img src="../../assets/images/downward02.png" v-else alt="" @click="SheetStateYear = !SheetStateYear">
          </div>
          <div class="filter_box" v-if="SheetStateYear">
            <div v-for="(item, index) in years" :key="index" @click="handleYearClick(item)">{{item}}</div>
          </div>
        </div>
        <div class="drop_item" @mouseenter="SheetStateMonth = true" @mouseleave="SheetStateMonth = false">
          <div class="src">
            <div>{{month && month.hk}}</div>
            <img src="../../assets/images/downward01.png" v-if="!SheetStateMonth" alt="" @click="SheetStateMonth = !SheetStateMonth">
            <img src="../../assets/images/downward02.png" v-else alt="" @click="SheetStateMonth = !SheetStateMonth">
          </div>
          <div class="filter_box" v-if="SheetStateMonth">
            <div v-for="(item, index) in filteredMonths" :key="index" @click="handleMonthClick(item)">{{item.hk}}</div>
          </div>
        </div>
        <div class="confirm_btn" @click="confirmData">Confirm</div>
      </div>
      <div style="display: flex; align-items: center; flex-direction: column" v-else>
        <div class="drop_item" @mouseenter="SheetStateYear = true" @mouseleave="SheetStateYear = false">
          <div class="src">
            <div class="course_name" :title="currentCourseName">{{currentCourseName}}</div>
            <img src="../../assets/images/downward01.png" v-if="!SheetStateYear" alt="" @click="SheetStateYear = !SheetStateYear">
            <img src="../../assets/images/downward02.png" v-else alt="" @click="SheetStateYear = !SheetStateYear">
          </div>
          <div class="filter_box" v-if="SheetStateYear">
            <div v-for="(item, index) in courseList" :key="index" @click="handleClick(item,index)">{{item.master_course_name}}</div>
          </div>
        </div>
        <div class="confirm_btn" @click="confirmData">Confirm</div>
      </div>
    </div>
</template>

<style scoped lang="scss">
</style>
